import { verifyRequiredBetaFeatures } from 'utils/betaFeatures/verifyRequiredBetaFeatures';

export default [{
  path: 'products',
  onEnterHandlers: [
    verifyRequiredBetaFeatures(['RAVEN_BOP']),
  ],
  getChildRoutes(location, callback) {
    import('./containers/Bop').then(component => {
      callback(null, [{
        path: ':sku',
        component: component.default,
      }]);
    });
  },
}];
